import { defineComponent as _defineComponent } from 'vue'
import CloseIcon from '~/assets/svg/close.vue.svg';

type BravadoComboBoxItemProps = {
  removable: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'BravadoComboBoxItem',
  props: {
    removable: { type: Boolean, default: false }
  },
  setup(__props: any) {



return { __sfc: true,CloseIcon }
}

})